import { Box } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { IPartnerSearchDataGridProps } from "../../interfaces/PartnerView.interfaces";
import { CustomPartnerList } from "../../SharedComponents/CustomPartnerList";
import { useWindowDimensions } from "../../SharedComponents/useWindowDimensions";
import { PartnerFilterPill } from "./PartnerFilterPill";

export default function PartnerDataGrid({ searchText }: IPartnerSearchDataGridProps) {
  const [filters, setFilters] = useState<any>({});
  const { height } = useWindowDimensions();
  const [filterPillContainerHeight, setFilterPillContainerHeight] = useState(0);
  const filterPillConainerRef = useRef<HTMLDivElement>(null);

  const onPrepareExtraFilter = (props: {
    field: string;
    type: BooleanConstructor | StringConstructor;
    data: string;
  }) => {
    const formFilterPredicate = (value: string) => {
      if (props.type === Boolean) {
        if (value === "1") {
          return `${props.field} eq 1`;
        }
        return `${props.field} eq 0`;
      }
      return `${props.field} eq '${value}'`;
    };
    const formFieldValuePredicate = () => {
      if (props.data) {
        const values = props.data.replace(/;$/, "").split(";");
        if (values.length > 1) {
          return "(" + values.map(formFilterPredicate).join(" or ") + ")";
        } else {
          return values.map(formFilterPredicate).join(" or ");
        }
      }
      return "";
    };

    if (props.data) {
      setFilters((prev: any) => ({
        ...prev,
        [props.field]: formFieldValuePredicate()
      }));
    } else {
      setFilters((prev: any) => {
        const current = { ...prev };
        delete current[props.field];
        return current;
      });
    }
  };
  const filterPillProps = {
    onIsDefaultChange: (data: any) => onPrepareExtraFilter({ data: data, field: columns.isDefault, type: Boolean }),
    onIsEliteChange: (data: any) => onPrepareExtraFilter({ data: data, field: columns.isElite, type: Boolean }),
    onIsChannelPartnerChange: (data: any) => onPrepareExtraFilter({ data: data, field: columns.isChannelPartner, type: Boolean }),
    onPartnerCountryChange: (data: any) => onPrepareExtraFilter({ data: data, field: columns.partnerCountry, type: String }),
  };

  useEffect(() => {
    const handleResize = () => {
      setFilterPillContainerHeight(filterPillConainerRef.current?.clientHeight ?? 0);
    };
    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <>
      <div ref={filterPillConainerRef} style={{ paddingBottom: 18 }}>
        <PartnerFilterPill {...filterPillProps} />
      </div>
      <Box
        sx={{
          width: "100%",
          height: `calc(${height}px - (175px + ${filterPillContainerHeight}px))`
        }}
      >
        <div
          role="tabpanel"
          id="partner-search-grid-tabpanel"
          aria-labelledby="aria-labelledby-partner-search-grid-tabpanel"
          style={{
            height: "100%",
            width: "calc(100% + 10px)"
          }}
        >
          <CustomPartnerList
            initialFilters={Object.values(filters).join(" and ")}
            searchText={searchText}
            skipColumnsFilterable={skipColumnsFilterable}
          />
        </div>
      </Box>
    </>
  );
}

const columns = {
  partnerCountry: "PartnerCountry",
  isElite: "IsElite",
  isDefault: "IsDefault",
  isChannelPartner: "IsChannelPartner"
};

const skipColumnsFilterable: string[] = [ "partnerCountry", "isElite", "isDefault", "isChannelPartner"];
